// TODO convert the stores urls in the same manner as the ones used on orders ( will need some changes on the sidebar and router)
export enum ToolsRoutes {
  zam = "/tools/zam",
  switchers = "/tools/switchers",
  subscriptions = "/tools/subscriptions",
  eraseCustomer = "/tools/erase-customer",
}
